import {
  Media,
  Post,
} from 'apps/shared/scripts/__generated__/graphql.generated';

import { FormValues } from '../components/CardPostForm';

const getMediaInitialValue = (media?: Media | null) => {
  if (!media) {
    return undefined;
  }
  // strip any __typename, etc. fields
  return {
    src: media.src,
    type: media.type,
  };
};

const getInitialValues = (post: Post): FormValues => {
  return {
    media: getMediaInitialValue(post.media),
    message: post.message ?? '',
    name: post.name,
  };
};

export default getInitialValues;
